import React, { memo } from 'react';
import { Step, Steps } from 'appkit-react';
import PropTypes from 'prop-types';

// import '@style/components/steps.scss';
import '../../styles/components/steps.scss';

function StepComp(props) {
  const { current, steps, kind, currentFullColor } = props;
  const step = currentFullColor ? current - 1 : current;

  return (
    <Steps currentStep={step} kind={kind}>
      {steps.map((item, index) => (
        <Step
          className={currentFullColor ? 'current-full-color' : ''}
          key={`step-${item}-${index}`}
        >
          {item}
        </Step>
      ))}
    </Steps>
  );
}

StepComp.defaultProps = {
  steps: [],
  current: 0,
  kind: 'steps',
  currentFullColor: false,
};

StepComp.propTypes = {
  current: PropTypes.number,
  steps: PropTypes.arrayOf(PropTypes.string),
  kind: PropTypes.string,
  currentFullColor: PropTypes.bool,
};

export default memo(StepComp);
